export default __webpack_public_path__ + "static/media/4.84aaff49.JPG";